import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ErrorCircleOutlinedStandard.js";
import d from "../components/PfIcon.js";
const r = (t, e) => {
  const o = {
    ...t,
    ...e.attrs
  };
  return a(d, i(o, {
    icon: n
  }), null);
};
r.displayName = "ErrorCircleOutlinedStandard";
r.inheritAttrs = !1;
export {
  r as default
};
